import { z } from "zod";

/** ISO calendar date YYYY-MM-DD (tenant-tz calendar concept). */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
/** ISO-8601 UTC instant. */
export const isoDateTime = z.string().datetime({ offset: true });
export const cents = z.number().int("must be integer cents");
export const nonNegCents = cents.min(0);
export const phone = z.string().min(7).max(32);
export const email = z.string().email();
export const id = z.string().min(1);

/** Base fields every persisted entity carries. */
export const baseEntity = z.object({
  tenantId: z.string().min(1),
  id: z.string().min(1),
  version: z.number().int().min(0),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
  deletedAt: isoDateTime.optional(),
});
